import { createTheme } from "@mui/material/styles";

// Function to get the CSS variable value or use default
const getMainColor = () => {
  if (typeof window !== 'undefined') {
    const computedStyle = getComputedStyle(document.documentElement);
    const mainColor = computedStyle.getPropertyValue('--main-color').trim();
    return mainColor || '#84bd00'; // fallback to default
  }
  return '#84bd00'; // default fallback for SSR
};

// Reads --main-color when called, so call it again once the brand stylesheet
// has loaded (App.js does) — a theme built at import time is always green.
export const createAppTheme = () => createTheme({
  spacing: (factor: number) => `${8 * factor}px`,
  palette: {
    primary: {
      main: getMainColor(),
    },
  },
  typography: {
    fontFamily: '"kiro", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    // MUI's default tooltip is a dark grey slab, which reads as someone else's
    // component next to the app's light surfaces. Same treatment as the cards
    // and panels: white, hairline border, soft shadow.
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "#ffffff",
          color: "#374151",
          border: "1px solid #e2e8f0",
          borderRadius: "8px",
          boxShadow: "0 6px 20px rgba(0, 0, 0, 0.12)",
          fontSize: "12.5px",
          fontWeight: 400,
          lineHeight: 1.5,
          padding: "8px 12px",
          // Long German sentences otherwise stretch into one thin line.
          maxWidth: 280,
        },
        arrow: {
          color: "#ffffff",
          // The arrow is a rotated square, so the border has to be drawn on it
          // separately or the tooltip's outline stops at the tip.
          "&::before": {
            backgroundColor: "#ffffff",
            border: "1px solid #e2e8f0",
            boxSizing: "border-box",
          },
        },
      },
    },
  },
});

// Make this a proper module
export {};
